import {getItemById, getItemByKey} from "./items";

const Airdrops = [
    {
        slug: 'sps-75m-6',
        key: 'sps-75m-6',
        contract_address: "0xE199610A6A3158ad86BD779d832fb44CCA428D9e",
        name: "SPS GROVE #6/8",
        description: "SPS GROVE airdrop #6/8. Uses tier system per NFT.\nSnapshot taken Feb 2026.",
        image: "/airdrops/sps-75m-2.png",
        items: [

        ],
        isToken: true
    },
    {
        slug: 'sps-75m-5',
        key: 'sps-75m-5',
        contract_address: "0x43af30d702f8909540a5a67ac346705249125232",
        name: "SPS GROVE #5/8",
        description: "SPS GROVE airdrop #5/8. Uses tier system per NFT.\nSnapshot taken Sept 2025.",
        image: "/airdrops/sps-75m-2.png",
        items: [

        ],
        isToken: true
    },
    {
        slug: 'sps-75m-4',
        key: 'sps-75m-4',
        contract_address: "0x954500E76D56a67E0F97cDBe0c7a9377790b10b8",
        name: "SPS GROVE #4/8",
        description: "SPS GROVE airdrop #4/8. Uses tier system per NFT.\nSnapshot taken May 2025.",
        image: "/airdrops/sps-75m-2.png",
        items: [

        ],
        isToken: true
    },
    {
        slug: 'sps-75m-3',
        key: 'sps-75m-3',
        contract_address: "0x8837d920744cc14ab7d97a3218a44eBe2195fa47",
        name: "SPS GROVE #3/8",
        description: "SPS GROVE airdrop #3/8. Uses tier system per NFT.\nSnapshot taken Feb 2025.",
        image: "/airdrops/sps-75m-2.png",
        items: [

        ],
        isToken: true
    },
    {
        slug: 'sps-75m-2',
        key: 'sps-75m-2',
        contract_address: "0x06b92be09Cf7Bf0f320cD172242adcEf34c20378",
        name: "SPS GROVE #2/8",
        description: "SPS GROVE airdrop #2/8. Uses tier system per NFT.\nSnapshot taken on Nov 26th 2024.",
        image: "/airdrops/sps-75m-2.png",
        items: [

        ],
        isToken: true
    },
    {
        slug: 'sps-75m-1',
        key: 'sps-75m-1',
        contract_address: "0xced83eDBb93CBaB513a46dc46c707B3856aA144f",
        name: "SPS GROVE #1/8",
        description: "SPS GROVE airdrop #1/8. Uses tier system per NFT.\nSnapshot taken on July 24th 2024.",
        image: "/airdrops/sps-75m-1.png",
        items: [

        ],
        isToken: true
    },
    {
        slug: 'sps',
        key: 'sps',
        contract_address: "0x02B52e4515A5131B4B08790Ebb50D3d56fFDF85F",
        name: "SPS Starter Pack",
        description: "Claim this GroveWars starter pack for owning a SPS Pine. Snapshot taken on July 24th 2024.",
        image: "/airdrops/sps@2x.png",
        items: [
            getItemByKey('character_secret_society_pineya'),
            getItemByKey('weapon_secret_society_t_fury')
        ]
    },
    {
        slug: 'ss-sps',
        key: 'ss-sps',
        contract_address: "0x694EeD4f2121937093Be70d7Bbe004b699211F23",
        name: "Silver Skull for SPS",
        description: "Claim this Silver Skull back swag for owning a SPS Pine. Snapshot taken on July 24th 2024.",
        image: "/airdrops/ss-sps@2x.png",
        items: [
            getItemByKey('back_swag_silver_pine_skull')
        ]
    },
    // {
    //     slug: 'elite-booster',
    //     key: 'elite-booster',
    //     contract_address: "0x",
    //     name: "ELite Booster Pack",
    //     description: "All Elite Edge Booster participants can claim this booster pack",
    //     image: "/airdrops/edge-node-booster.png",
    //     items: [
    //         getItemByKey('character_edge_node_pineya'),
    //         getItemByKey('weapon_edge_node_t_fury'),
    //         getItemByKey('back_swag_edge_node_booster_pack')
    //     ]
    // }
];

export default Airdrops;

export const getAirdropByKey = (key) => {
    return Airdrops.find(a => a.key === key);
}

export const getAirdropBySlug = (slug) => {
    return Airdrops.find(a => a.slug === slug);
}